export default "<p>\n  sms-dashboard-new works!\n</p>\n";